<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.sms_settings && source">
  <app-popup-header title="{{localService.languageContent.sms_settings.header}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-4">
        <ngx-select [(ngModel)]="selectedNotificationType" [optionValueField]="'key'" [optionTextField]="'value'"
          [items]="source.notificationTypes" [noAutoComplete]="true" (select)="onLoad()">
        </ngx-select>
      </div>
      <div class="col-8" style="text-align: right;">
        <app-label [Text]="localService.languageContent.sms_settings.alert_limit" [IsColonRequired]="true"/>
        <input autocomplete="off" type="number" class="number" [ngClass]="source.content.value ? 'en' : ''"
          [(ngModel)]="source.content.value" (keypress)="localService.isNumberOnly($event)"
          placeholder="{{localService.languageContent.sms_settings.alert_limit}}"
          title="{{localService.languageContent.sms_settings.alert_limit}}" style="width: 75px;" />
        <label style="font-weight: normal; margin-right: 10px;margin-left: 30px;">
          <input type="checkbox" [(ngModel)]="isActive" [disabled]="!isShowActive" />
          <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12" *ngIf="selectedForCustomer">
        <div class="box custom_rows_body">
          <div style="text-align:center">
            <label>
              <input type="checkbox" [(ngModel)]="isAllCustomer" (change)="onAction(1)" />
              <span>{{localService.languageContent.sms_settings.for_customer}}</span>
            </label>
          </div>
          <div class="row styled_row" *ngFor="let item of selectedForCustomer">
            <label style="font-weight: normal;">
              <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onAction(3)" />
              <span class="normal_color">{{item.value}}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="col-6" *ngIf="selectedForBusiness && !localService.isHideDummy">
        <div class="box custom_rows_body">
          <div style="text-align:center">
            <label>
              <input type="checkbox" [(ngModel)]="isAllBusiness" (change)="onAction(2)" />
              <span>{{localService.languageContent.sms_settings.for_business}}</span>
            </label>
          </div>
          <div class="row styled_row" *ngFor="let item of selectedForBusiness">
            <label style="font-weight: normal;">
              <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onAction(4)" />
              <span class="normal_color">{{item.value}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="source.similarSettings.length > 0">
      <div class="col-md-12">
        <div class="box">
          <div style="text-align:justify;">
            <label style="font-weight: normal;">{{localService.languageContent.sms_settings.apply_to}}</label>
          </div>
          <label style="font-weight: normal;margin-left:10px;" *ngFor="let item of source.similarSettings">
            <input type="checkbox" [(ngModel)]="item.isReadonly" />
            <span [ngStyle]="{'color' : item.v2 == '1' ? 'green' : 'red'}">{{item.v1}}&nbsp;&nbsp;</span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onSave()">{{source.content.key == '' ?
      localService.languageContent.common.create : localService.languageContent.common.update}}</button>
  </div>
</div>